import { NODE_TYPES } from './nodeConstants';

export const NODE_SECTION_TYPES: Record<string, string> = {
  ANNOTATIONS: 'annotations',
  FILTER_AND_FLOW: 'filterAndFlow',
  DELAY: 'delay',
  MESSAGES: 'messages',
  USER_UPDATES: 'userUpdates',
  INTEGRATIONS: 'integrations',
};

export const NODE_SECTION_TITLES: Record<string, string> = {
  [NODE_SECTION_TYPES.FILTER_AND_FLOW]: 'Filters and flow',
  [NODE_SECTION_TYPES.MESSAGES]: 'Messages',
  [NODE_SECTION_TYPES.DELAY]: 'Delays',
  [NODE_SECTION_TYPES.USER_UPDATES]: 'User updates',
  [NODE_SECTION_TYPES.INTEGRATIONS]: 'Integrations',
};

export const NODE_TYPES_IN_SECTION: Record<string, string[]> = {
  [NODE_SECTION_TYPES.ANNOTATIONS]: [NODE_TYPES.NOTE, NODE_TYPES.TILESET],
  [NODE_SECTION_TYPES.MESSAGES]: [
    NODE_TYPES.SEND_EMAIL,
    NODE_TYPES.SEND_PUSH,
    NODE_TYPES.SEND_SMS,
    NODE_TYPES.SEND_WEB_PUSH,
    NODE_TYPES.SEND_IN_APP,
    NODE_TYPES.SEND_EMBEDDED,
    NODE_TYPES.SEND_WHATSAPP,
    NODE_TYPES.CHANNEL_OPT,
  ],
  [NODE_SECTION_TYPES.DELAY]: [NODE_TYPES.DELAY, NODE_TYPES.HOLD, NODE_TYPES.HOLD_UNTIL_REPLY],
  [NODE_SECTION_TYPES.FILTER_AND_FLOW]: [
    NODE_TYPES.FIELDS_MATCH,
    NODE_TYPES.AB_SPLIT,
    NODE_TYPES.ATTRIBUTE_SPLIT,
    NODE_TYPES.TRIGGER_WORKFLOW,
  ],

  [NODE_SECTION_TYPES.USER_UPDATES]: [
    NODE_TYPES.ADD_CONTACT,
    NODE_TYPES.MODIFY_CHANNEL_SUBSCRIPTION,
    NODE_TYPES.CHANGE_CONTACT_FIELD,
  ],
  [NODE_SECTION_TYPES.INTEGRATIONS]: [NODE_TYPES.CALL_WEBHOOK, NODE_TYPES.ADD_USER_TO_FB],

  // Legacy node, won't show up in the node tile bar
  LEGACY: [
    NODE_TYPES.MODIFY_MESSAGE_TYPE,
    NODE_TYPES.UPDATE_CONTACT_WEBHOOK,
    NODE_TYPES.REMOVE_USER_FROM_FB,
    NODE_TYPES.REMOVE_CONTACT,
  ],
};

export const NODE_TYPE_TO_SECTION_MAP: Record<string, string> = Object.entries(
  NODE_TYPES_IN_SECTION,
).reduce((acc: Record<string, string>, [section, nodes]) => {
  nodes.forEach((node) => {
    acc[node] = section;
  });

  return acc;
}, {});
